import axios from 'axios'

class DocumentoPncpApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async enviarDocumentoPncp(objt) {
		return await axios.post(this.urlBuilder.pncp.getUrlEnviar(objt.idEntidadePai), objt)
	}

	async excluirDocumentoPncp({ idDocumento }) {
		return await axios.delete(this.urlBuilder.pncp.getUrlExcluir(idDocumento))
	}
}

export default DocumentoPncpApiClient
